export const SIGN_UP_CONFIG = {
  QUERY_PARAMS: {
    POSITION_ID: 'position_id',
    ID_CODE: 'id_code',
    ACCOUNT_TYPE: 'signup_account_type',
  },
  ACCOUNT_TYPES: {
    EMPLOYER: 'employer',
  },
  ROUTES: {
    DOCUMENTS: '/sign-up',
    EMPLOYER_CHECKOUT: '/employer-checkout',
    EMPLOYER_PAYMENT_COMPLETE: '/employer-payment-complete',
  },
  EMPLOYER: {
    PAYMENT_CANCEL_URL: 'https://advisorinterview.com/',
    PROVISIONING: {
      POLL_INTERVAL_MS: 1500,
      TIMEOUT_MS: 30000,
    },
  },
} as const;

export type SignUpAccountType = (typeof SIGN_UP_CONFIG.ACCOUNT_TYPES)[keyof typeof SIGN_UP_CONFIG.ACCOUNT_TYPES];
